import { ActionTree } from 'vuex'
import { PersonalInfoState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<PersonalInfoState, RootState> = {
}
